import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Jssidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csoperator(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
      <Sides/>

      <Helmet>
 
 <title>Learn Free JavaScript Operator Tutorials For Beginners CodeExampler</title>
 <meta name="description" content="Javascript Operator tutorial for beginners Operators in Javascript are used special symbols which perform any type of operations.CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,Javascript Operator,Operator in Javascript Examples,what is javascript operator,javascript operator precedence" />
 <link rel="canonical" href="https://www.codeexampler.com/javascript-operator" />
 </Helmet>

 <div className='lg:pl-56'>
    <h1 className="m-4 mh1">What is a javascript operator</h1>
    <div className="first">
        <a href="/javascript-identifier">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/javascript-first-program">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <h2 className="mt-4 mh2">An Operator in Javascript</h2>
    <p className="mt-4 para">Operators in Javascript use special symbols that perform any operation.<br/>
or<br/>
The Javascript operator is a special symbol that uses in the expression.
</p>


<h2 className="headings">An operator in Javascript Syntax code</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>        

  {"\n"}
  <span className="qwerty-4">Example - </span>
  <span className="qwerty-1">106</span>
  <span className="qwerty">/</span>
  <span className="qwerty-1">8</span>
  <span className="qwerty">%</span>
  <span className="qwerty-1">40</span>

  {"\n"}  {"\n"}
 
 


    
    
    
    
    
       
        </code>
      </pre>        
    </div>
    <div>
      <h3 className="headings">Answer</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;(+-/%) this is an operator </span>          
          {"\n"}
          
       
            </code>{"   "}
            </pre>
      </div>
    </div>




<h2 className="headings">An operator in Javascript Syntax code</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>        

  {"\n"}
  <span className="qwerty-4">c</span>
  <span className="qwerty-8">=</span>
  <span className="qwerty-4">a</span>
  <span className="qwerty-8">+</span>
  <span className="qwerty-4">b </span>
  <span className="qwerty-5">so</span>

  {"\n"} 
  <span className="qwerty-8">=</span>
  <span className="qwerty-8">,</span>
  <span className="qwerty-8">+ </span>
  <span className="qwerty-5">are an operator</span>
  
  
  
   {"\n"}

   <span className="qwerty-4">a</span>
  <span className="qwerty-8">,</span>
  <span className="qwerty-4">b</span>
  <span className="qwerty-8">,</span>
  <span className="qwerty-4">c </span>
  <span className="qwerty-5">The Operator in Javascript Syntax code</span>
  
  
  
   {"\n"}
 
 
   {"\n"}

    
    
    
    
    
       
        </code>
      </pre>        
    </div>





<h2 className="headings">An operator in Javascript Syntax code</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>        

  {"\n"}
  <span className="qwerty-4">a</span>
  <span className="qwerty-8">=</span>
  <span className="qwerty-4">b</span>
  <span className="qwerty-8">+</span>
  <span className="qwerty-4">c</span>
  <span className="qwerty-8">-</span>
  <span className="qwerty-4">d;</span>

  {"\n"} 
  <span className="qwerty-8">=</span>
  <span className="qwerty-8">,</span>
  <span className="qwerty-8">+</span>
  <span className="qwerty-8">,</span>
  <span className="qwerty-8">- </span>
  <span className="qwerty-5">are operators means there are 3 operators</span>
  
  
  
   {"\n"}

   <span className="qwerty-4">a</span>
  <span className="qwerty-8">,</span>
  <span className="qwerty-4">b</span>
  <span className="qwerty-8">,</span>
  <span className="qwerty-4">c</span>
  <span className="qwerty-8">,</span>
  <span className="qwerty-4">d </span>
  <span className="qwerty-5">are operands means there are 4 operands</span>
  
  
  
   {"\n"}
 
 
   {"\n"}

    
    
    
    
    
       
        </code>
      </pre>        
    </div>

<h2 className="mt-4 mh2">Javascript Operator Types:</h2>



<h2 className="mt-4 mh2">1, Arithmetic operator:</h2>
<h3 className="mt-4 mh3">+ add<br/>
-Sub<br/>
Multiply<br/>
/ division<br/>
% modules<br/>
++ increment<br/>
-- decrement<br/>
</h3>


<h2 className="headings">Javascript Operator Example code</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
{"\n"}

<span className="qwerty-3">&#60;</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
          {"\n"}


          <span className="qwerty-4">&nbsp;&nbsp;var </span>
          <span className="qwerty-3">a</span>
          <span className="qwerty-8">=</span>
          <span className="qwerty-1">8;</span>
          <span className="qwerty-3">b</span>
          <span className="qwerty-8">=</span>
          <span className="qwerty-1">4;</span>
          {"\n"}
          <span className="qwerty-4">&nbsp;&nbsp;var </span>
          <span className="qwerty-3">c</span>
          <span className="qwerty-8">=</span>
          <span className="qwerty-3">a</span>
          <span className="qwerty-8">+</span>
          <span className="qwerty-3">b;</span>
          {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;document</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">c</span> 
      <span className="qwerty-1">);</span>
      {"\n"}
<span className="qwerty-3">&#60;/</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
            {"\n"}
    
    
    
            {"\n"}
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;12</span>          
          {"\n"} 
          
            </code>{"   "}
            </pre>
      </div>
    </div>



<h2 className="headings">Javascript Operator Example code</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>        

  {"\n"}
  <span className="qwerty-4">C</span>
  <span className="qwerty-8">=</span>
  <span className="qwerty-4">a</span>
  <span className="qwerty-8">-</span>
  <span className="qwerty-4">b;</span>

  {"\n"} 
  <span className="qwerty-4">C</span>
  <span className="qwerty-8">=</span>
  <span className="qwerty-4">a</span>
  <span className="qwerty-8">*</span>
  <span className="qwerty-4">b;</span>

  {"\n"} 
  <span className="qwerty-4">C</span>
  <span className="qwerty-8">=</span>
  <span className="qwerty-4">a</span>
  <span className="qwerty-8">/</span>
  <span className="qwerty-4">b;</span>

  {"\n"} 
  <span className="qwerty-4">C</span>
  <span className="qwerty-8">=</span>
  <span className="qwerty-4">a</span>
  <span className="qwerty-8">%</span>
  <span className="qwerty-4">b;</span>

  {"\n"} 
  <span className="qwerty-4">C</span>
  <span className="qwerty-8">=</span>
  <span className="qwerty-4">a</span>
  <span className="qwerty-8">++;</span>
  <span className="qwerty-5"> OR a++; </span>
  {"\n"} 
  <span className="qwerty-4">C</span>
  <span className="qwerty-8">=</span>
  <span className="qwerty-4">b</span>
  <span className="qwerty-8">---</span>
  <span className="qwerty-5"> OR b--; </span>

  {"\n"} 
  
   {"\n"}
 
        </code>
      </pre>        
    </div>

<h2 className="mt-4 mh2">2, Relational operator:</h2>
<h3 className="mt-4"> Greater than  <br/>
&#60;less than <br/>
&#62;=greater than or equal to<br/>
&#60;= -less than or equal to<br/>
!= - not equal to<br/>
== -equal to<br/>
</h3>

<h2 className="mt-4 mh2">Javascript Relational Operator Example</h2>




    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
{"\n"}

<span className="qwerty-3">&#60;</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
          {"\n"}


          <span className="qwerty-4">&nbsp;&nbsp;var </span>
          <span className="qwerty-3">a</span>
          <span className="qwerty-8">=</span>
          <span className="qwerty-1">10;</span>
          <span className="qwerty-3">b</span>
          <span className="qwerty-8">=</span>
          <span className="qwerty-1">20;</span>
          {"\n"}
          <span className="qwerty-5">&nbsp;&nbsp;if</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span> 
        <span className="qwerty-8">&#60;</span> 
        <span className="qwerty-1">b</span>
        <span className="qwerty-1">)</span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-1">"B is Greater"</span> 
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
  
      {"\n"}
<span className="qwerty-3">&#60;/</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
            {"\n"}
    
    
    
            {"\n"}
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;B is Greater</span>          
          {"\n"} 
          
            </code>{"   "}
            </pre>
      </div>
    </div>
    


<h2 className="mt-4 mh2">Javascript Relational Operator Example</h2>




    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
{"\n"}

<span className="qwerty-3">&#60;</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
          {"\n"}


          <span className="qwerty-4">&nbsp;&nbsp;var </span>
          <span className="qwerty-3">a</span>
          <span className="qwerty-8">=</span>
          <span className="qwerty-1">20;</span>
          <span className="qwerty-3">b</span>
          <span className="qwerty-8">=</span>
          <span className="qwerty-1">20;</span>
          {"\n"}
          <span className="qwerty-5">&nbsp;&nbsp;if</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span> 
        <span className="qwerty-8">==</span> 
        <span className="qwerty-1">b</span>
        <span className="qwerty-1">)</span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-1">"Both are Equal"</span> 
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
  
      {"\n"}
<span className="qwerty-3">&#60;/</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
            {"\n"}
    
    
    
            {"\n"}
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;Both are Equal</span>          
          {"\n"} 
          
            </code>{"   "}
            </pre>
      </div>
    </div>
    

<h2 className="mt-4 mh2">3, Logic operator:</h2>
<h3 className="mt-4 mh3">And  &#38;&#38;<br/>
Or   &#124;&#124;<br/>
Not&#33;
</h3>



<h2 className="mt-4 mh2">4, Bitwise operator:</h2>
<h3 className="mt-4 mh3">
&#62;&#62; - right shift<br/>
    &#60;&#60; - left shift<br/>
^ xor<br/>
~ B Not<br/>
</h3>

<h2 className="mt-4 mh2">5, Assignment operator:</h2>
<h3 className="mt-4 mh3">=<br/>
+=<br/>
-=<br/>
*=<br/>
/=<br/>
%=<br/>
&#47;&#47;=<br/>
**=<br/>
&#38;=<br/>
&#60;&#60;=<br/>
&#62;&#62;=<br/>
^=<br/>
</h3>



<h2 className="headings">6, Identifier operator in Javascript:</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
{"\n"}

<span className="qwerty-3">&#60;</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
          {"\n"}

          {"\n"}

          <span className="qwerty-4">&nbsp;&nbsp;var </span>
          <span className="qwerty-3">a</span>
          <span className="qwerty-8">=</span>
          <span className="qwerty-1">5;</span>
          {"\n"}
          
  <span className="qwerty-2">&nbsp;&nbsp;document</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span>
        <span className="qwerty-8">+</span>
        <span className="qwerty-1">"</span>
        <span className="qwerty-3">&#60;</span>
<span className="qwerty-1">br/</span>
          <span className="qwerty-3">&#62;</span>
          <span className="qwerty-1">"</span>
      <span className="qwerty-1">);</span>
      {"\n"} 

      <span className="qwerty-4">&nbsp;&nbsp;a</span>
      <span className="qwerty-8">=</span>
      <span className="qwerty-4">a</span>
      <span className="qwerty-8">*</span>
      <span className="qwerty-1">4;</span>
      {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;document</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span>
      <span className="qwerty-1">);</span>
      {"\n"}
      {"\n"}
<span className="qwerty-3">&#60;/</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
            {"\n"}
    
    
    
            {"\n"}
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;5 </span>          
          {"\n"} 
          <span className="qwerty-3">&nbsp;20 </span>          
          {"\n"} 
          
            </code>{"   "}
            </pre>
      </div>
    </div>

<h2 className="mt-4 mh2">7, The Conditional operator (? :) in Javascript:-
</h2>
<p className="mt-4 para">A Conditional operator is known as a <span className="bold"> ternary operator.</span><br/>
The main point is that this Conditional operator  consists of three operands.<br/>
</p>



<h2 className="headings">Javascript Conditional Operator Syntax code</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
{"\n"}

          <span className="qwerty-4">&nbsp;&nbsp;Variable </span>
          <span className="qwerty-3">a</span>
          <span className="qwerty-8">=</span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-3">expression</span>
          <span className="qwerty-1">)</span>
          <span className="qwerty-8">?</span>
          <span className="qwerty-3">true</span>
          <span className="qwerty-8">:</span>
          <span className="qwerty-3">false;</span>
          {"\n"}
          
    
    
            {"\n"}
       
        </code>
      </pre>        
    </div>


<h2 className="mt-4 mh2">8,unary operator:</h2>
<h3 className="mt-4 mh3">++<br/>
--
</h3>


<h2 className="headings">Javascript unary Operator Example</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
{"\n"}

<span className="qwerty-3">&#60;</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
          {"\n"}

          {"\n"}

          <span className="qwerty-4">&nbsp;&nbsp;var </span>
          <span className="qwerty-3">a</span>
          <span className="qwerty-8">=</span>
          <span className="qwerty-1">10;</span>
          {"\n"}
          
  <span className="qwerty-2">&nbsp;&nbsp;document</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span>
      <span className="qwerty-1">);</span>
      {"\n"} 
      <span className="qwerty-2">&nbsp;&nbsp;document</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-1">"</span>
        <span className="qwerty-3">&#60;</span>
<span className="qwerty-1">br/</span>
          <span className="qwerty-3">&#62;</span>
          <span className="qwerty-1">"</span>
      <span className="qwerty-1">);</span>
      {"\n"} 
      <span className="qwerty-3">&nbsp;&nbsp;a</span>
      <span className="qwerty-8">++;</span>
      {"\n"}
          
  <span className="qwerty-2">&nbsp;&nbsp;document</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span>
      <span className="qwerty-1">);</span>
      {"\n"}
      {"\n"}
<span className="qwerty-3">&#60;/</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
            {"\n"}
    
    
    
            {"\n"}
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;10 </span>          
          {"\n"} 
          <span className="qwerty-3">&nbsp;11 </span>          
          {"\n"} 
          
            </code>{"   "}
            </pre>
      </div>
    </div>



<h2 className="headings">Q-If you add more no inside unary Javascript operator?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
{"\n"}

<span className="qwerty-3">&#60;</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
          {"\n"}

          {"\n"}

          <span className="qwerty-4">&nbsp;&nbsp;var </span>
          <span className="qwerty-3">a</span>
          <span className="qwerty-8">=</span>
          <span className="qwerty-1">20;</span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;a</span>
      <span className="qwerty-8">=</span>
      <span className="qwerty-3">a</span>
      <span className="qwerty-1">2;</span>
      {"\n"}
          
  <span className="qwerty-2">&nbsp;&nbsp;document</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span>
      <span className="qwerty-1">);</span>
      {"\n"}   {"\n"}
      <span className="qwerty-5">&nbsp;&nbsp;OR</span>
      {"\n"}   {"\n"}
      <span className="qwerty-5">&nbsp;&nbsp;Error Show :</span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;a</span>
      <span className="qwerty-8">++++;</span>
      {"\n"}
          
  <span className="qwerty-2">&nbsp;&nbsp;document</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span>
      <span className="qwerty-1">);</span>
      {"\n"}
      {"\n"}
<span className="qwerty-3">&#60;/</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
            {"\n"}
    
    
    
            {"\n"}
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;22 </span>          
          {"\n"} 
          <span className="qwerty-5">&nbsp;error  </span>
          {"\n"} 
            </code>{"   "}
            </pre>
      </div>
    </div>




<h2 className="headings">Q-Change position of the unary operator?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
{"\n"}

<span className="qwerty-5">If we use (++a)</span>
{"\n"}{"\n"}
<span className="qwerty-3">&#60;</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
          {"\n"}

          {"\n"}

          <span className="qwerty-4">&nbsp;&nbsp;var </span>
          <span className="qwerty-3">a</span>
          <span className="qwerty-8">=</span>
          <span className="qwerty-1">20;</span>
          {"\n"}
          <span className="qwerty-4">&nbsp;&nbsp;var </span>
          <span className="qwerty-3">b;</span>
          {"\n"}
          
  <span className="qwerty-2">&nbsp;&nbsp;document</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span>
      <span className="qwerty-1">);</span>
      {"\n"}

      <span className="qwerty-2">&nbsp;&nbsp;document</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"</span>
        <span className="qwerty-3">&#60;</span>
<span className="qwerty-1">br/</span>
          <span className="qwerty-3">&#62; "</span>
      <span className="qwerty-1">);</span>
      {"\n"}  
      <span className="qwerty-3">&nbsp;&nbsp;b</span>
      <span className="qwerty-8">=++</span>
      <span className="qwerty-3">a;</span>
      {"\n"}
      <span className="qwerty-2">&nbsp;&nbsp;document</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">b</span>
      <span className="qwerty-1">);</span>
      {"\n"}


<span className="qwerty-3">&#60;/</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
            {"\n"}
    
            {"\n"}


<span className="qwerty-5">If we use (a++)</span>
{"\n"}{"\n"}
<span className="qwerty-3">&#60;</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
          {"\n"}

          {"\n"}

          <span className="qwerty-4">&nbsp;&nbsp;var </span>
          <span className="qwerty-3">a</span>
          <span className="qwerty-8">=</span>
          <span className="qwerty-1">20;</span>
          {"\n"}
          <span className="qwerty-4">&nbsp;&nbsp;var </span>
          <span className="qwerty-3">b;</span>
          {"\n"}
          
  <span className="qwerty-2">&nbsp;&nbsp;document</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span>
      <span className="qwerty-1">);</span>
      {"\n"}

      <span className="qwerty-2">&nbsp;&nbsp;document</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-1">"</span>
        <span className="qwerty-3">&#60;</span>
<span className="qwerty-1">br/</span>
          <span className="qwerty-3">&#62;</span>
          <span className="qwerty-1">"</span>
      <span className="qwerty-1">);</span>
      {"\n"}  
      <span className="qwerty-3">&nbsp;&nbsp;b</span>
      <span className="qwerty-8">=</span>
      <span className="qwerty-3">a</span>
      <span className="qwerty-8">++</span>
      <span className="qwerty-3">;</span>
      {"\n"}
      <span className="qwerty-2">&nbsp;&nbsp;document</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">b</span>
      <span className="qwerty-1">);</span>
      {"\n"}


<span className="qwerty-3">&#60;/</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
            {"\n"}
    
    
    
    
            {"\n"}
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;20 </span>          
          {"\n"} 
          <span className="qwerty-3">&nbsp;21  </span>         
          {"\n"} {"\n"}
          <span className="qwerty-5">&nbsp;20</span>   
          {"\n"}
          <span className="qwerty-5">&nbsp;20</span>   
          {"\n"}
          
            </code>{"   "}
            </pre>
      </div>
    </div>

  <h1 className="mt-5">  </h1>
   
  <div className="back">
        <a href="/javascript-identifier">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/javascript-first-program">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)
}
export default Csoperator;